import { LBButton } from '@linearb/buzz';
import useSensorReauthHandler from 'common/hooks/auth/useSensorReauthHandler';
import { useMemo } from 'react';

const ScopesValidationsActionButton = ({
  sensor,
  scopesValidations,
  modalHandler
}) => {
  const reauthHandler = useSensorReauthHandler(sensor);

  const buttonConfig = useMemo(() => {
    const { isLoading, isValid, isError } = scopesValidations;
    if (isLoading)
      return {
        text: 'Loading...',
        onClick: null,
        disabled: true
      };

    if (isError)
      return {
        text: 'Try again',
        onClick: scopesValidations.refetch
      };

    if (isValid)
      return {
        text: 'Continue',
        onClick: modalHandler.closeModal
      };

    return {
      text: 'Reauthorize',
      onClick: reauthHandler.onReauth
    };
  }, [scopesValidations, modalHandler]);

  return (
    <LBButton
      type='button'
      onClick={buttonConfig.onClick}
      disabled={buttonConfig.disabled}
    >
      {buttonConfig.text}
    </LBButton>
  );
};

export default ScopesValidationsActionButton;
